// extracted by mini-css-extract-plugin
export default {"root-proxy-select-field":"root-proxy-select-field---kCs7g"};